import classNames from 'classnames';
import { useCmsClientContext } from '../../utils/cmsPageContext';
import { getClientTranslations } from '../../utils/translations/getClientTranslations';
import { LoanRewardPillTranslations } from './i18n';

export type LoanRewardPillProps = {
  /** Currency-prefixed, separated total, e.g. "S$1,200". */
  value: string;
  /** Table Builder draws it at cell size, Quick Answer at the primary-cell size. */
  size?: 'cell' | 'cell-primary';
  className?: string;
};

/**
 * The personal-loan reward total as an "Up to" pill (CMS-1922 R2, CMS-1928 R4).
 * One string, so the prefix renders inline in the value's style. Never wraps:
 * Quick Answer cells truncate rather than grow.
 */
export const LoanRewardPill = ({
  value,
  size = 'cell',
  className,
}: LoanRewardPillProps) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(LoanRewardPillTranslations, context);

  return (
    <span
      className={classNames(
        'inline-block w-fit whitespace-nowrap rounded-radius/tooltip',
        'bg-fill/primary-light px-spacing/padding/soft-8px py-spacing/padding/soft-4px',
        size === 'cell'
          ? 'font-font-weight/table-cell-strong text-font-size/table-cell leading-line-height/table-cell'
          : 'font-font-weight/table-cell-primary text-font-size/table-cell-primary leading-line-height/table-cell-primary',
        'text-fill/primary-dark',
        className,
      )}
    >
      {`${staticText.reward_up_to} ${value}`}
    </span>
  );
};
